export default "<p>navigator-incompatible works!</p>\n"